// Sections
export const PROFILE = "p";
export const BILLING = "b";

// Features
export const ESTIMATES = 'bes';
export const INVOICES = 'bin';
export const CLIENTS = 'bcl';
export const ITEMS = 'bit';
export const SETTINGS = 'bse';
export const SUBSCRIPTION = 'bsu';
export const USERS = 'bur';

// Actions
export const VIEW = "vie";
export const CREATE = "cre";
export const EDIT = "edi";
export const DELETE = "del";

// Roles
export const ROLE_ADMIN = "a"
export const ROLE_VIEWER = "v"